<app-block-wrapper [_editable]="_editable" [style]="style">
  @if (posts()) {
    @if (!posts().stories.length) {
      <div class="empty">EMPTY BLOG POST LINK LIST</div>
    } @else {
      <div class="posts">
        @for (post of posts().stories; track post) {
          <app-blog-post-link-list-item [post]="post" [index]="$index"></app-blog-post-link-list-item>
        }
      </div>
      @if (pages().length > 1) {
        <div class="pages">
          @for (page of pages(); track page.number) {
            <a [routerLink]="page.link" [class.active]="page.active">
              {{ page.number }}
            </a>
          }
        </div>
      }
    }
  }
</app-block-wrapper>
